<template>
  <div class="member-export-filter">
    <button class="btn" @click="isModalShow = true">
      <v-icon class="mr-2">get_app</v-icon>
      <span>匯出報表</span>
    </button>
    <div v-if="isModalShow" class="member-export-filter__modal-wrap">
      <div class="member-export-filter__modal block">
        <!-- head -->
        <div class="form-item px-5 py-18px">
          <h3>匯出報表</h3>
        </div>
        <!-- body -->
        <div>
          <!-- 篩選註冊產品 -->
          <div class="form-item d-flex pa-5">
            <h4 class="w-100px mr-50px">篩選註冊產品</h4>
            <div class="flex-grow-1 flex-basis-0 my-n2">
              <SimpleSelectWithSearch
                buttonWidth="100%"
                modalWidth="100%"
                buttonPlaceholder="請選擇產品類別"
                inputPlaceholder="搜尋產品類別"
                :limitOfWordLengthInInput="30"
                :selectedValue.sync="categoryOfPorductFilter"
                :options="[
                  'Category1',
                  'Category2',
                  'Category3',
                  'Category4',
                  'Category11',
                ]"
              ></SimpleSelectWithSearch>
            </div>
          </div>
          <!-- 篩選日期區間 -->
          <div class="form-item d-flex pa-5">
            <h4 class="w-100px mr-50px">篩選日期區間</h4>
            <div class="flex-grow-1 flex-basis-0 my-n2">
              <DateFilter
                modalWidth="540px"
                buttonPlaceholder="請選擇日期區間"
                :dateOfRegisterFilter.sync="filter.createdAtRange"
              ></DateFilter>
            </div>
          </div>
          <!-- 篩選國家別 -->
          <div class="form-item d-flex pa-5">
            <h4 class="w-100px mr-50px">篩選國家別</h4>
            <div class="flex-grow-1 flex-basis-0 my-n2">
              <SimpleSelectWithSearch
                buttonWidth="100%"
                modalWidth="100%"
                modalBodyHeight="208px"
                buttonPlaceholder="請選擇國家別"
                inputPlaceholder="搜尋國家別"
                :limitOfWordLengthInInput="30"
                :selectedValue.sync="filter.category"
                :options="countryOptions"
                item-value="country"
                item-text="country"
              ></SimpleSelectWithSearch>
            </div>
          </div>
          <!-- 篩選生日月份 -->
          <div class="form-item d-flex pa-5">
            <h4 class="w-100px mr-50px">篩選生日月份</h4>
            <div class="flex-grow-1 flex-basis-0 my-n2">
              <SimpleSelect
                buttonWidth="100%"
                modalWidth="100%"
                modalBodyHeight="208px"
                buttonPlaceholder="請選擇生日月份"
                :selectedValue.sync="filter.month"
                :options="monthOptions"
              ></SimpleSelect>
            </div>
          </div>
          <!-- 篩選年齡 -->
          <div class="form-item d-flex pa-5">
            <h4 class="w-100px mr-50px">篩選年齡</h4>
            <div class="flex-grow-1 flex-basis-0 my-n2">
              <SimpleSelect
                buttonPlaceholder="請選擇年齡"
                buttonWidth="100%"
                modalWidth="100%"
                modalBodyHeight="208px"
                modalTop="-220px"
                :selectedValue.sync="filter.age"
                :options="ageOptions"
              ></SimpleSelect>
            </div>
          </div>
        </div>
        <!-- foot -->
        <div class="pa-5 text-right">
          <button class="btn w-100px mr-10px" @click="cancelHandler">
            取消
          </button>
          <button class="btn w-100px btn-primary" @click="exportHandler">
            匯出
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// Filter
import DateFilter from '@/components/F-1a__ADATA-members_Filter-StartEndDate.vue';
import SimpleSelectWithSearch from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import SimpleSelect from '@/components/Selection/SimpleSelect.vue';
import Str from '@/services/str';

export default {
  components: {
    DateFilter,
    SimpleSelectWithSearch,
    SimpleSelect,
  },
  data: () => ({
    isModalShow: false,
    // filter
    categoryOfPorductFilter: null,
    filter: {
      keyword: null,
      createdAtRange: [],
      country: null,
      isSubscription: null,
      age: null,
      month: null,
    },
  }),
  computed: {
    ...mapState('member', [
      'monthOptions',
      'ageOptions',
      'countryOptions',
    ]),
  },
  methods: {
    cancelHandler() {
      this.clearFilter();
      this.isModalShow = false;
    },
    exportHandler() {
      window.open(`${process.env.VUE_APP_API_URL}/export/member?${Str.query(this.filter)}`);
      this.clearFilter();
    },
    clearFilter() {
      this.filter = {
        keyword: null,
        createdAtRange: [],
        country: null,
        isSubscription: null,
        age: null,
        month: null,
      };
    },
  },
};
</script>

<style lang="scss">
.member-export-filter {
  position: relative;

  &__modal-wrap {
    position: fixed;
    background-color: rgba(170, 170, 170, 0.8);
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }
  &__modal {
    width: 720px;
    margin: 0 auto;
    margin-top: 168px;
    background-color: #fff;
  }
}
</style>
